import {makeAutoObservable, set} from "mobx";

export enum AlertType {
	Error = "Error",
	Warning = "Warning",
	Info = "Info",
}

export class AlertStore {
	open = false;
	title?: string = undefined;
	message = "";
	type: AlertType = AlertType.Error;

	constructor() {
		makeAutoObservable(this);
	}
}

export const alertStore = new AlertStore();

export function fancyAlert(message: string, type?: AlertType, title?: string) {
	set(alertStore, {
		open: true,
		message,
		title,
		type: type || AlertType.Error,
	});
}
